/* eslint-disable no-param-reassign */
import breadcrumbSchema from '../schemas/breadcrumb';
import courseSkeletonSchema from '../schemas/course';

const batchSchema = ({ batchDetails = {}, batch = {} }) => {
  const { goal = {} } = batchDetails;
  const graph = [];
  if (batchDetails.name) {
    batchDetails.topic = goal.name;
    batchDetails.permalink = batch.permalink;
    graph.push(courseSkeletonSchema(batchDetails));
  }
  const breads = [
    {
      name: 'Explore',
      url: 'https://unacademy.com/explore'
    },
    {
      name: goal.name,
      url: goal.permalink
    },
    {
      name: 'Batches',
      url: `${goal.permalink}/batches`
    },
    { name: batch.name, url: batch.permalink }
  ];
  graph.push(breadcrumbSchema(breads));
  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };
  return schema;
};

export default batchSchema;
